import React, { useCallback } from 'react';

import { InfoCircleIcon } from '@vlabs/icons';
import validate from '@vlabs/shared/validators';
import {
  Control, SettingsItemWrapper, Fold, Tooltip,
} from '@vlabs/uikit';
import { isEmpty } from 'lodash';
import { useFormContext, useFormState, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { useUpdateAllPoliciesField } from '../hooks';
import { useLicense } from '../LicenseProvider';
import st from './FaceQualitySubForm.module.sass';

function DeepfakeSubForm() {
  const { isFeatureAvailable } = useLicense();
  const isDeepfakeAvailable = isFeatureAvailable('estimations.deepfake');

  const { t } = useTranslation();
  const { control, register } = useFormContext();
  const { errors } = useFormState();
  const estimateDeepfake = useWatch({ name: 'estimate_deepfake.estimate' });

  useUpdateAllPoliciesField({
    on: useCallback(() => estimateDeepfake === false, [estimateDeepfake]),
    path: 'filters.deepfake',
    value: [],
    updateIf: useCallback((v) => !isEmpty(v), []),
  });
  const deepfakeTitle = (
    <div className={st.FoldTitle}>
      <h5>{t('handlers:policies.detect_policy.estimate_deepfake.estimate')}</h5>
      {!isDeepfakeAvailable && (
        <Tooltip
          className="Tooltip_ui"
          data-tooltip-content={t('handlers:policies.detect_policy.tooltip.deepfake license is required')}
          tooltipProps={{ effect: 'solid' }}
        >
          <InfoCircleIcon className={st.Tooltip_Icon_disabled} />
        </Tooltip>
      )}
    </div>
  );

  return (
    <Fold
      control={control}
      disabled={!isDeepfakeAvailable}
      isOpen={useWatch({ name: 'estimate_deepfake.estimate' })}
      name="estimate_deepfake.estimate"
      switch
      testId="estimate_deepfake"
      title={deepfakeTitle}
    >
      <SettingsItemWrapper
        contentClassName="MatchPolicy_Input"
        data-tip={t('handlers:policies.detect_policy.estimate_deepfake.real_threshold.tooltip')}
        title={t('handlers:policies.detect_policy.estimate_deepfake.real_threshold.label')}
      >
        <Control.Input
          {...register('estimate_deepfake.real_threshold', {
            min: validate.gte(0),
            max: validate.lte(1),
            validate: validate.number(),
          })}
          errors={errors}
        />
      </SettingsItemWrapper>
    </Fold>
  );
}

export { DeepfakeSubForm };
